const feedbackModals = {
  'confirmationModal.title': 'Warning',
  'confirmationModal.description':
    'Once executed, this action can not be undone.',
  'confirmationModal.type': 'Type',
  'confirmationModal.toPerform': 'to perform this action',
  'confirmationModal.conclude': 'Conclude',
  'balanceModal.title':
    'Whoops! Is possible close only accounts with no balance',
  'balanceModal.description':
    'To remove the balance, access the Backoffice, locate the customer and perform one of the operations:',
  'balanceModal.confirm': 'understood',
  'balanceModal.cashOutLink': 'Cash-Out TED/TEF',
  'balanceModal.sendLink': 'Issue OP',
  'balanceModal.settingsLink': 'Make adjustment',
  'bankSlipsOpenedModal.title':
    'Whoops! This account has open bank slips and can not be closed at this time.',
  'successModal.title': 'Success!',
  'successModal.description': 'Operation succeed',
  'errorModal.title': 'Whoops! Something went wrong',
  'errorModal.description': 'Operation not succeed. ',
  'errorModal.okButton': 'ok',
};

export default feedbackModals;
